export class Deferrable<T> implements PromiseLike<T> {
  promise: Promise<T>;
  #resolve?: (value: T | PromiseLike<T>) => void;
  #reject?: (value: T | PromiseLike<T>) => void;

  #resolved = false;
  #rejected = false;

  constructor() {
    this.promise = new Promise((resolve, reject) => {
      this.#resolve = resolve;
      this.#reject = reject;
    });
  }

  then<TResult1 = T, TResult2 = never>(
    onfulfilled?: ((value: T) => TResult1 | PromiseLike<TResult1>) | null | undefined,
    onrejected?: ((reason: any) => TResult2 | PromiseLike<TResult2>) | null | undefined
  ): PromiseLike<TResult1 | TResult2> {
    return this.get().then(onfulfilled, onrejected);
  }

  get() {
    return this.promise;
  }

  async resolve(value?: T | PromiseLike<T>): Promise<void> {
    this.#resolve?.(value as T);
    this.#resolved = true;
  }

  async reject(value?: T | PromiseLike<T> | Error) {
    this.#reject?.(value as T);
    this.#rejected = true;
  }

  get fulfilled() {
    return this.#resolved || this.#rejected;
  }

  static resolved<T>(value: T) {
    const deferrable = new Deferrable<T>();
    deferrable.resolve(value).catch(() => {});
    return deferrable;
  }
}
